document.querySelectorAll('[data-fibrax-other-products]').forEach((root) => {
  if (root.dataset.fxReady) return;
  root.dataset.fxReady = 'true';
  root.querySelectorAll('[data-fx-other-add]').forEach((button) => {
    button.addEventListener('click', () => window.FibraxCore.addToCart({
      variantId: button.dataset.variantId,
      quantity: 1,
      root,
      button,
      properties: { Origen: 'Otros productos FIBRAX' }
    }));
  });
});
